module.exports = __webpack_public_path__ + "static/img/pricing-credit-card.2ad5a813.svg";